import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import classnames from 'classnames';

// app
import styles from './SearchResult.styles';
import * as utils from 'utils';

// mui
import { withStyles, Typography, IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

export class SearchResult extends PureComponent {
  static propTypes = {
    count: PropTypes.number.isRequired,
    query: PropTypes.string.isRequired,
    category: PropTypes.string,
    handleSearchReset: PropTypes.func,
    nestedClasses: PropTypes.shape({
      root: PropTypes.string,
      text: PropTypes.string,
    }),
  };

  static defaultProps = {
    nestedClasses: {},
  };

  render() {
    const { count, query, category, handleSearchReset, nestedClasses, classes } = this.props;

    const label = category ? 'app.searchResultIn' : 'app.searchResult';

    // abort if no search query made
    if (!query) return null;

    return (
      <div className={classnames(classes.root, nestedClasses.root)}>
        <Typography
          variant="body2"
          className={classnames(classes.text, nestedClasses.text)}
          dangerouslySetInnerHTML={{
            __html: utils.string.t(label, { count: count, query: query, category: category }),
          }}
        />

        {handleSearchReset && (
          <IconButton onClick={handleSearchReset}>
            <ClearIcon classes={{ root: classes.noResultsLink }} />
          </IconButton>
        )}
      </div>
    );
  }
}

export default compose(withStyles(styles))(SearchResult);
